// extracted by mini-css-extract-plugin
export var eoiBadgeContent = "RegisterInterest-module--eoi-badge-content--fOhFo";
export var icon = "RegisterInterest-module--icon--qMwgW";
export var isManuCtaAside = "RegisterInterest-module--isManuCtaAside--r1dg6";
export var primary = "#06004d";
export var secondary = "#4dafd7";